import { useMutation } from "@tanstack/react-query"
import { createTask } from "../../../../api/tasks/createTask"

export const useCreateTask = () => {
  
  return useMutation({
    mutationKey: ["createTask"],
    mutationFn: createTask
  })
}